import { z } from "zod";

const millimetersSchema = z
  .string()
  .trim()
  .min(1)
  .transform((value) => Number(value.replace(",", ".")))
  .pipe(z.number().min(0));

export const NestingInputsFormSchema = z.object({
  cutWidth: millimetersSchema,
  skeletonWidth: millimetersSchema,
  material: z.string().nullable(),
});

export type NestingInputsFormInput = z.input<typeof NestingInputsFormSchema>;
export type NestingInputsFormValues = z.output<typeof NestingInputsFormSchema>;

export const buildNestingInputsDefaultValues = (layout: {
  cutWidth: number | null;
  skeletonWidth: number | null;
}): NestingInputsFormInput => ({
  cutWidth: String(layout.cutWidth ?? ""),
  skeletonWidth: String(layout.skeletonWidth ?? ""),
  material: null,
});
